import api from './axiosApi'
import { bare } from './axiosApi'

/**
 * Login with email and password credentials (used by DebugLogin)
 */
export async function login(email: string, password: string) {
  const form = new URLSearchParams()
  form.append('grant_type', 'password')
  form.append('username', email)
  form.append('password', password)

  const response = await bare.post('/auth/login', form, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic Og==',
    },
  })

  return response.data
}

/**
 * Exchange OIDC authorization code for JWT tokens via backend
 */
export async function ssoTokenExchange(
  code: string,
  redirectUri: string,
  codeVerifier: string
) {
  const response = await bare.post('/auth/sso/token', {
    code,
    redirect_uri: redirectUri,
    code_verifier: codeVerifier,
  })
  return response.data
}

/**
 * SSO logout — tells backend to invalidate session with IBM Verify
 */
export async function ssoLogout() {
  const response = await api.post('/auth/sso/logout')
  return response.data
}
